import { cn } from "@/lib/cn";

const PROVIDERS = [
  {
    name: "Google",
    label: "Google로 계속하기",
    className: "border-[#dadce0] bg-white text-[#3c4043]",
    badgeClassName: "bg-[#4285F4] text-white",
    letter: "G",
  },
  {
    name: "Kakao",
    label: "카카오로 계속하기",
    className: "border-[#FEE500] bg-[#FEE500] text-[#191919]",
    badgeClassName: "bg-[#191919] text-[#FEE500]",
    letter: "K",
  },
  {
    name: "Naver",
    label: "네이버로 계속하기",
    className: "border-[#03C75A] bg-[#03C75A] text-white",
    badgeClassName: "bg-white text-[#03C75A]",
    letter: "N",
  },
];

export function SnsAuthButtons() {
  return (
    <div>
      <div className="flex flex-col gap-2">
        {PROVIDERS.map((p) => (
          <button
            key={p.name}
            type="button"
            disabled
            title="아직 연동 준비 중입니다"
            className={cn(
              "flex h-10 w-full items-center justify-center gap-2 rounded-md border px-3.5 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50",
              p.className,
            )}
          >
            <span
              aria-hidden
              className={cn(
                "flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold",
                p.badgeClassName,
              )}
            >
              {p.letter}
            </span>
            {p.label}
          </button>
        ))}
      </div>
      <p className="mt-2 text-center text-xs text-muted-soft">SNS 로그인은 준비 중입니다.</p>
    </div>
  );
}
